export { default } from './Thoughts';
